import { TableCheckboxInput, Visible } from 'coreOld/components';
import { SelectionOptions } from 'coreOld/enums';

import { List, ListItem, Wrapper } from './selectAllStyle';

interface IProps {
  getToggleAllRowsSelectedProps;
  onItemClick;
  onChange;
  isMenuOpen: boolean;
  selectMenuOptions: SelectionOptions[];
  disabled?: boolean;
}

const SelectAllView = ({
  getToggleAllRowsSelectedProps,
  isMenuOpen = false,
  selectMenuOptions,
  onItemClick,
  onChange,
  disabled = false,
}: IProps) => {
  return (
    <Wrapper>
      <TableCheckboxInput
        {...getToggleAllRowsSelectedProps()}
        onChange={(event) => !disabled && onChange(event)}
        disabled={disabled}
      />

      <Visible when={isMenuOpen}>
        <List onClick={(event) => onItemClick(event)}>
          {selectMenuOptions?.map((option: SelectionOptions) => (
            <ListItem key={option}>{option}</ListItem>
          ))}
        </List>
      </Visible>
    </Wrapper>
  );
};

export default SelectAllView;
